export const changePipelineStatusAction = 'changePipelineStatusAction';
export const resyncCollectionsAction = 'resyncCollectionsAction';
export const downloadETLScriptAction = 'downloadETLScriptAction';
export const getRegionsAction = 'getRegionsAction';
